import React, { useState } from 'react';
import { ImageCarousel } from '..';
import { socmedType } from '../../configs/socmedType';
import TwitterMediaHandler from './twitterMedia';
import FacebookMediaHandler from './facebookMedia';

const Index = (props) => {
  const {
    accountType,
    accountId,
    lineItemIds,
    linkData,
    style,
    documents = [],
    height,
    width,
    setLoading,
    adTweets,
  } = props;

  const [loadingMedia, setLoadingMedia] = useState(true);

  const isEmptyDocuments = documents?.length === 0;

  const postList = {
    [socmedType.TWT]: TwitterMediaHandler({
      accountId,
      accountType,
      lineItemIds,
      setLoading,
      setLoadingMedia,
      adTweets,
    }),
    [socmedType.FB_ADS]: FacebookMediaHandler({
      linkData,
      accountId,
      setLoading,
      setLoadingMedia,
      isEmptyDocuments,
      documents,
      accountType,
    }),
  };

  const postMedia = postList[accountType] || [];

  return (
    <ImageCarousel
      imagesData={postMedia}
      style={style}
      height={height}
      width={width}
      loading={loadingMedia}
    />
  );
};

export default Index;
